import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const PrivacyContentFromMarkdown = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Cargar el archivo markdown
    fetch('/content/privacy-policy.md')
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load privacy policy');
        }
        return response.text();
      })
      .then(text => {
        setContent(text);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading privacy policy:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="text-center p-5">Loading...</div>;
  }

  return (
    <div className="privacy-content-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          // Personalizar el renderizado de elementos
          h1: ({ node, ...props }) => (
            <h1 className="mt-4 mb-3" style={{ fontSize: '2rem', fontWeight: 'bold' }} {...props} />
          ),
          h2: ({ node, ...props }) => (
            <h2
              className="mt-4 mb-3 bg-transparent"
              style={{ fontSize: '1.5rem', fontWeight: 'bold' }}
              {...props}
            />
          ),
          h3: ({ node, ...props }) => (
            <h3 className="mt-4 mb-3" style={{ fontSize: '1.25rem', fontWeight: 'bold' }} {...props} />
          ),
          h4: ({ node, ...props }) => (
            <h4 className="mt-3 mb-2" style={{ fontSize: '1.1rem', fontWeight: 'bold' }} {...props} />
          ),
          h5: ({ node, ...props }) => (
            <h5 className="mt-2 mb-2" style={{ fontSize: '1rem', fontWeight: 'bold' }} {...props} />
          ),
          p: ({ node, ...props }) => (
            <p className="mb-3" style={{ lineHeight: '1.6', fontSize: '1rem' }} {...props} />
          ),
          ul: ({ node, ...props }) => (
            <ul className="mb-3" style={{ paddingLeft: '1.5rem', fontSize: '0.95rem' }} {...props} />
          ),
          ol: ({ node, ...props }) => <ol className="mb-3" style={{ paddingLeft: '1.5rem' }} {...props} />,
          li: ({ node, ...props }) => <li className="mb-1" style={{ fontSize: '0.95rem' }} {...props} />,
          table: ({ node, ...props }) => (
            <div className="table-responsive my-4">
              <table
                className="table table-bordered table-striped"
                style={{ fontSize: '0.9rem' }}
                {...props}
              />
            </div>
          ),
          thead: ({ node, ...props }) => <thead className="table-light" {...props} />,
          a: ({ node, href, ...props }) => {
            // Si es un enlace interno (hash), no abrir en nueva pestaña
            const isInternal = href && href.startsWith('#');
            return (
              <a
                href={href}
                className="text-primary"
                style={{ textDecoration: 'underline', fontSize: 'inherit' }}
                target={isInternal ? '_self' : '_blank'}
                rel={isInternal ? undefined : 'noopener noreferrer'}
                {...props}
              />
            );
          },
          strong: ({ node, ...props }) => <strong style={{ fontWeight: 'bold' }} {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default PrivacyContentFromMarkdown;
